const MessageSize = {
    large: 2,
    medium: 1,
    small: 0,

    className: size => {
        switch (size) {
            case MessageSize.small:
                return 'small';
            case MessageSize.medium:
                return 'medium';
            default:
            case MessageSize.large:
                return 'large';
        }
    },
};

class Messages {
    constructor() {
        this.activeTimeout = -1;
        this.messageElement = null;
        this.pad = 30;
        this.setTimeout(0);
    }

    /**
     * Initialise all abbr tags on the page with the message library
     */
    abbrInit() {
        const abbrevs = document.querySelectorAll('abbr[title]');

        if (abbrevs.length > 0) {
            document.addEventListener('keydown', t => {
                if (this.messageElement && (t.key === 'Escape' || t.key === 'Tab')) {
                    if (t.key === 'Escape') t.preventDefault();
                    this.destroy();
                }
            });
            document.addEventListener('click', t => {
                if (this.messageElement && t.target.tagName !== 'ABBR') {
                    this.destroy();
                }
            });
        }

        Array.from(abbrevs).forEach(e => {
            e.setAttribute('tabindex', 0);
            e.addEventListener(
                'click',
                t => {
                    this.display({ timeout: 20000, clientY: t.clientY }, t.target.textContent, t.target.title);
                },
                false
            );

            e.addEventListener('keydown', t => {
                if (t.key === ' ' || t.key === 'Spacebar' || t.key === 'Enter') {
                    t.preventDefault();
                    if (this.messageElement) this.destroy();
                    else
                        this.display(
                            20000,
                            document.activeElement.getBoundingClientRect().y,
                            t.target.textContent,
                            t.target.title
                        );
                }
            });
        });
    }

    /**
     *
     * @param {*} options A structure containing the optional values for the message. Properties can be any of the following
     *                      timeout - seconds until the message is automatically closed)
     *                      clientY - Y offset of the click location
     *                      clientX - X offset of the click location
     *                      size - One of the MessageSize constants (affects >768px wide only, otherwise always full width)
     * @param {*} heading The heading for the message (optional)
     * @param  {...any} paragraphs One or more paragraphs to display
     */
    display(options, heading, ...paragraphs) {
        const { timeout, clientY, clientX, size } = options;

        const m = document.getElementById('message');
        if (m) {
            document.body.removeChild(m);
        }

        if (!document.getElementById('message')) {
            const messagesDiv = document.createElement('div');
            messagesDiv.id = 'message';
            messagesDiv.classList.add(MessageSize.className(size));

            const headingDiv = document.createElement('heading');

            if (heading && heading.length > 0) {
                const h = document.createElement('h1');
                h.appendChild(document.createTextNode(heading));
                headingDiv.appendChild(h);
            }

            const b = document.createElement('button');
            b.type = 'button';
            b.classList.add('close');
            b.setAttribute('aria-label', 'Close');
            b.title = 'Click to close';
            b.addEventListener('click', () => {
                this.destroy();
            });

            const s = document.createElement('span');
            s.setAttribute('aria-hidden', true);
            s.innerHTML = '&times;';
            b.appendChild(s);
            headingDiv.appendChild(b);

            messagesDiv.appendChild(headingDiv);

            const d = document.createElement('div');

            paragraphs.forEach(text => {
                if (!text.startsWith('<p>')) {
                    const p = document.createElement('p');
                    p.innerHTML = text;
                    d.appendChild(p);
                } else {
                    d.innerHTML = text;
                }
            });

            messagesDiv.appendChild(d);

            document.body.appendChild(messagesDiv);

            this.messageElement = messagesDiv;

            if (clientY || clientX) {
                const { x, y } = this.position(clientY, clientX, messagesDiv);

                const offsetX = x === undefined ? '0px' : `${x}px`;
                const offsetY = y === undefined ? '50%' : `${y}px`;

                messagesDiv.style.cssText = `--desktop-message-offset: ${offsetY}; --desktop-message-x: ${offsetX};`;
            }
        }

        this.messageElement.classList.add('active');
        this.setTimeout(timeout);
    }

    position(clientY, clientX, messagesDiv) {
        let x = undefined;
        let y = undefined;

        if (clientY) {
            const offsetY = clientY + messagesDiv.clientHeight + this.pad;
            y = offsetY < window.innerHeight ? clientY + this.pad : clientY - (messagesDiv.clientHeight + this.pad);
            if (y < 0 || y > window.innerHeight) y = undefined;
        }

        if (clientX) {
            // if possible we need to adjust so that the center point is as close as possible to the click point without going off screen

            // Center of the window
            const centerX = window.innerWidth * 0.5;
            let cx = clientX;

            if (cx - messagesDiv.clientWidth * 0.5 <= 20) cx = messagesDiv.clientWidth * 0.5 + 20;
            if (cx + messagesDiv.clientWidth * 0.5 >= window.innerWidth - 20)
                cx = window.innerWidth - (messagesDiv.clientWidth * 0.5 + 20);

            x = cx - centerX;
        }

        return { x, y };
    }

    setTimeout(time) {
        window.clearTimeout(this.activeTimeout);
        if (time && time > 0) {
            this.activeTimeout = window.setTimeout(() => {
                this.destroy();
            }, time);
        }
    }

    remove(e) {
        if (e.target) {
            document.body.removeChild(this);
        }
    }

    destroy() {
        const e = this.messageElement;
        this.messageElement = null;

        if (e) {
            e.addEventListener('webkitAnimationEnd', this.remove, false);
            e.addEventListener('animationend', this.remove, false);
            e.addEventListener('oanimationend', this.remove, false);

            e.classList.remove('active');
            e.classList.add('inactive');
        }
    }
}
